// @flow

import React from 'react';

import Help from './Help';
import Questions from './Questions';

import type { FormActions } from 'app/get-help/components/Form/types';
import type { SelectedNode } from 'app/get-help/utils/tree/types';
import type { States } from 'app/get-help/components/Form/machine';

type Props = {
  nodes: SelectedNode[],
  actions: FormActions,
  state: States,
};

export const State = (props: Props) => {
  const { state } = props;

  if (state === 'help' || state === 'submitting' || state === 'submitted') {
    return <Help {...props} />;
  }

  return <Questions {...props} />;
};

export default State;
